<template>
  <form v-if="loaded" class="nameform m-center" @submit="submit">
    <div class="content flex flex-wrap mb-10">
      <h1 v-if="userMinor" class="mb-6 text-center">
        Approvazione richiesta carta per
        {{ userMinor.firstName + " " + userMinor.lastName }}
      </h1>
      <div class="w-full px-3 mb-6">
        <div class="tnb-input" :class="{ error: $v.userParentType.$error }">
          <label for="citizenzhip"
            >Seleziona il tipo di legame con il titolare</label
          >
          <select
            v-model.trim="$v.userParentType.$model"
            class="tnb-select"
            id="userParentType"
          >
            <option value=""></option>
            <option value="PARENT">Genitore</option>
            <option value="TUTOR">Tutore</option>
          </select>

          <ValidationText :value="$v.userParentType" />
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button class="btn" type="submit" :disabled="$v.$invalid">
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ValidationText from "@/components/ValidationText";
import RegistrationService from "@/services/RegistrationService";
import UserService from "@/services/UserService";

export default {
  name: "TutorSetType",
  components: {
    ValidationText
  },

  data() {
    return {
      loaded: false,
      userParentType: null,
      userMinor: {}
    };
  },
  validations: {
    userParentType: {
      required
    }
  },
  async mounted() {
    const asTutor = await RegistrationService.asTutor();
    const regId = RegistrationService.getCurrentRegistrationId();
    const registrationStatus = asTutor?.data?.filter(d => d.id === regId)[0];
    this.userMinor = registrationStatus.user;
    const tutorship = await UserService.getTutorship(
      registrationStatus.user.id
    );

    const userParentType = tutorship.data.userParentType;
    if (userParentType) {
      this.stepCompleted();
    } else {
      this.loaded = true;
    }
    console.log(userParentType);
  },
  methods: {
    submit() {
      event.preventDefault();
      UserService.userParentType(this.userMinor.id, this.userParentType);
      this.stepCompleted();
    },
    stepCompleted() {
      this.$root.$emit("submitStep");
    }
  }
};
</script>
<style lang="less" scoped>
h1 {
  margin: 0px auto 30px;
}
</style>
